module.exports = __webpack_public_path__ + "static/media/front.cca70a94.png";